import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
import { Grid } from '@material-ui/core';
import { IntelligentPhotoCaptureAddViewConstants } from '../../constants';
export const StyledGridTextContainer = styled(Grid) `
	margin: ${Magnetic.spacer04};
`;
export const StyledInstructions = styled('div') `
	font-size: ${Magnetic.fontSize14};
	text-align: center;
	line-height: 1.5;

	ul,
	ol {
		list-style-position: inside;
	}

	ul {
		list-style-type: disc;
	}

	ol {
		list-style-type: decimal;
	}
`;
export const StyledHeaderSectionContainer = styled('div') `
	margin-bottom: ${Magnetic.spacer08};
`;
export const StyledFirstTextTitle = styled.div `
	font-size: ${Magnetic.fontSize14};
	font-weight: ${Magnetic.fontWeightSemibold};
	line-height: normal;
	margin-bottom: ${Magnetic.spacer04};
`;
export const StyledSecondTextTitle = styled.div `
	font-size: ${Magnetic.fontSize14};
	line-height: normal;
`;
export const StyledDivImageSection = styled(Grid) `
	position: relative;
	display: flex;
	justify-content: center;
	margin: 0 auto ${Magnetic.spacer16};
	&#${`Intelligent_Guided_Photo_Capture_defaultImageSection${IntelligentPhotoCaptureAddViewConstants.WIDE_ENHANCED}`} {
		width: 300px;
		margin: ${Magnetic.spacer20} auto ${Magnetic.spacer20};
	}
`;
export const StyledImageWrapper = styled.div `
	position: relative;
`;
export const StyledImageSection = styled.img `
	max-height: 250px;
	max-width: 300px;
`;
export const StyledActionButtonContainer = styled(Grid) `
	padding: 0px ${Magnetic.spacer20};
`;
export const StyledPageGuidanceInfoContainer = styled(Grid) `
	margin: ${Magnetic.spacer20};
`;
export const StyledImageModalBox = styled(Grid) `
	&#${IntelligentPhotoCaptureAddViewConstants.IMAGE_CONTAINER_BOX} {
		position: relative;
		display: inline-block;
	}
`;
export const StyledDeleteRetakeIcon = styled(Grid) `
	position: absolute;
	top: ${Magnetic.spacer40};
	right: ${Magnetic.spacer04};
`;
export const StyledImageDetailModal = styled('div') `
	&#${IntelligentPhotoCaptureAddViewConstants.MAIN_CONTAINER} {
		position: absolute;
		width: 100%;
		left: 0px;
		top: 0px;
		height: 100vh;
		background-color: ${Magnetic.backgroundNeutral01d};
		z-index: 99999;
	}
`;
export const StyledImageContainerBox = styled('div') `
	&#${IntelligentPhotoCaptureAddViewConstants.WRAPPER} {
		width: 100%;
		height: 100%;
		padding: ${Magnetic.spacer20};
		overflow-y: auto;
		text-align: center;
	}
`;
export const StyledDeleteIconSpan = styled('span', {
    shouldForwardProp: prop => prop !== 'iconColor'
})(({ iconColor }) => `
	position: absolute;
	right: ${Magnetic.spacer12};
	top: ${Magnetic.spacer12};
	font-size: ${Magnetic.fontSize16};
	color: ${Magnetic.colorWhite};
	background: ${iconColor || Magnetic.actionableColor};
	padding: ${Magnetic.spacer08} ${Magnetic.spacer12};
	z-index: 1;
`);
export const StyledRefreshIconSpan = styled('span', {
    shouldForwardProp: prop => !['iconColor', 'isParentImage'].includes(prop)
})(({ isParentImage, iconColor }) => `
	position: absolute;
	right: ${!!isParentImage ? Magnetic.spacer12 : Magnetic.spacer48};
	top: ${Magnetic.spacer12};
	margin-right: ${!isParentImage && Magnetic.spacer08};
	font-size: ${Magnetic.fontSize16};
	color: ${Magnetic.colorWhite};
	background: ${iconColor || Magnetic.actionableColor};
	padding: ${Magnetic.spacer08} ${Magnetic.spacer12};
`);
//# sourceMappingURL=IntelligentPageGuidanceInfo.style.js.map